import { BrowserRouter, Routes, Route, useLocation, Outlet } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/hooks/useAuth';
import Header from '@/components/Header';
import ProtectedRoute from '@/components/ProtectedRoute';
import BadgeWatcher from '@/components/BadgeWatcher';import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Signup from '@/pages/Signup';
import Markets from '@/pages/Markets';
import Trade from '@/pages/Trade';
import Futures from '@/pages/Futures';
import Wallet from '@/pages/Wallet';
import Staking from '@/pages/Staking';
import Kyc from '@/pages/Kyc';
import Dashboard from '@/pages/Dashboard';
import Admin from '@/pages/Admin';
import Referrals from '@/pages/Referrals';
import Alerts from '@/pages/Alerts';
import Traders from '@/pages/Traders';
import TraderProfile from '@/pages/TraderProfile';
import Convert from '@/pages/Convert';
import SharedTemplate from '@/pages/SharedTemplate';
import TemplateMarketplace from '@/pages/TemplateMarketplace';
import Battles from '@/pages/Battles';
import Launchpad from '@/pages/Launchpad';
import NFTs from '@/pages/NFTs';
import AdminDashboard from '@/pages/AdminDashboard';
import AuthCallback from '@/pages/AuthCallback';
import ListYourCoin from '@/pages/ListYourCoin';
import MyListings from '@/pages/MyListings';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import Profile from '@/pages/Profile';
import EmailVerificationBanner from '@/components/EmailVerificationBanner';

function AppShell() {
  return (
    <div className="min-h-screen bg-[#0B0E11] text-[#EAECEF]">
      <EmailVerificationBanner />
      <Header />
      <Outlet />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback BEFORE any other routing (URL fragment check)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/u/:handle" element={<AppShell />}>
        <Route index element={<Profile />} />
      </Route>
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route element={<AppShell />}>
        <Route path="/" element={<Landing />} />
        <Route path="/markets" element={<Markets />} />
        <Route path="/trade/:coinId" element={<Trade />} />
        <Route path="/futures" element={<Futures />} />
        <Route path="/futures/:symbol" element={<Futures />} />
        <Route path="/staking" element={<Staking />} />
        <Route path="/kyc" element={<ProtectedRoute><Kyc /></ProtectedRoute>} />
        <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
        <Route path="/convert" element={<ProtectedRoute><Convert /></ProtectedRoute>} />
        <Route path="/convert/shared/:share_id" element={<SharedTemplate />} />
        <Route path="/marketplace/templates" element={<TemplateMarketplace />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
        <Route path="/alerts" element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
        <Route path="/traders" element={<Traders />} />
        <Route path="/trader/:id" element={<TraderProfile />} />
        <Route path="/battles" element={<Battles />} />
        <Route path="/launchpad" element={<Launchpad />} />
        <Route path="/list-your-coin" element={<ListYourCoin />} />
        <Route path="/my-listings" element={<ProtectedRoute><MyListings /></ProtectedRoute>} />
        <Route path="/nfts" element={<NFTs />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BadgeWatcher />
        <AppRouter />
        <Toaster theme="dark" position="top-right" toastOptions={{
          style: { background: '#181A20', color: '#EAECEF', border: '1px solid #2B3139', borderRadius: 2 }
        }} />
      </AuthProvider>
    </BrowserRouter>
  );
}
